const styles = {
    global: {
        body: {
            color: '#1A1A1A',
        },
        'b, strong': {
            fontWeight: '600',
        },
    },
};

export default styles;
